<!-- 审核 -->
<template>
  <div class="diseaseList">
    <!-- 筛选区 + 新增 + 统计，与表格拼接成整块白卡 -->
    <div class="filter-bar">
      <el-form :inline="true" class="filter-form">
        <el-form-item label="门店ID" size="small">
          <el-input
            v-model="listQuery.store_id"
            placeholder="请输入门店ID"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" size="small">
          <el-input
            v-model="listQuery.user_phone"
            placeholder="请输入店长手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item class="item-search">
          <el-button type="primary" @click="handleSearch" size="small" v-waves
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item class="item-add">
          <el-button type="primary" size="small" v-waves @click="handleAdd"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
      <div class="filter-meta">
        共 <span class="meta-num">{{ listQuery.total || 0 }}</span> 张会员卡
      </div>
    </div>
    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        :height="tableHeight"
        header-bg-color="#F1F6FC"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="card_status" slot-scope="scope">
          <VipCardStatus :value="scope.row.card_status" />
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <!-- <el-button size="mini" type="text" @click="handleEdit(row)" primary
              >编辑</el-button
            > -->
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0);"
              @click="handleDelete(row)"
              >删除</el-button
            >
          </div>
        </template>
      </ElTable>
    </div>
    <!-- 弹窗表单 -->
    <el-dialog
      :title="dialogName"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="460px"
      custom-class="vip-dialog"
    >
      <div class="dialog-tip">
        填写门店信息与发卡数量，即可创建一张新的会员卡。
      </div>
      <el-form ref="form" :model="dialogForm" label-position="top" class="vip-form">
        <el-form-item label="门店ID">
          <el-input
            clearable
            v-model="dialogForm.store_id"
            placeholder="请输入门店ID"
          ></el-input>
        </el-form-item>
        <el-form-item label="数量">
          <el-input
            clearable
            v-model="dialogForm.count"
            placeholder="请输入发卡数量"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import Percentage from "@/components/filters/Percentage.vue";
import VipCardStatus from "@/components/filters/vipCardStatus.vue";
import KindTab from "@/components/tab/kindTab/index.vue";
// import waves from "@/directive/waves/index.js"; // 水波纹指令
import {
  selectVipCard,
  addVipCard,
  updateVipCard,
  deleteVipCard,
} from "@/services/mini/vipCard.js";
export default {
  components: {
    ElTable,
    Percentage,
    VipCardStatus,
    KindTab,
  },
  // directives: {
  //   waves,
  // },
  async created() {
    this.getListData();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  data() {
    return {
      loading: false,
      /* 视口高度，用于计算表格自适应高度 */
      winHeight: window.innerHeight,
      listQuery: {
        pageNumber: 1,
        pageSize: 15,
        total: 0,
      },
      /* 表格数据 */
      tableData: [],
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogForm: {},
      roleList: [
        { id: 0, name: "待处理" },
        { id: 1, name: "已处理" },
      ],
    };
  },
  computed: {
    filterQueryFormItems,
    listHeader,
    /* 表格高度：按实际行数收缩，数据少时不再留出大片空白 */
    tableHeight() {
      const rows = this.loading ? 10 : Math.max(this.tableData.length, 1);
      const need = 48 + rows * 50;
      const max = this.winHeight - 300;
      return `${Math.max(Math.min(need, max), 200)}px`;
    },
  },
  watch: {},
  methods: {
    handleResize() {
      this.winHeight = window.innerHeight;
    },
    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      this.loading = true;
      const { data, code, count } = await selectVipCard(listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    /* 搜索按钮 */
    async handleSearch() {
      this.listQuery.pageNumber = 1;
      this.getListData();
    },

    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 切换tab */
    // clickTableTab(e) {
    //   this.getListData({ ...this.listQuery, state: e.id });
    // },

    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
      this.dialogName = "创建会员卡";
      this.dialogForm = {};
    },
    /* 修改 */
    handleEdit(row) {
      console.log(row);
      this.dialogVisible = true;
      this.dialogName = "编辑会员卡";
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    /* 保存 */
    save() {
      if (this.dialogName === "创建会员卡") {
        this.loading = true;
        addVipCard(this.dialogForm).then((res) => {
          console.log("创建会员卡", res);
          if (res.code === 200) {
            this.listQuery.pageNumber = 1;
            this.$message({
              type: "success",
              message: "创建成功!",
            });
            this.dialogVisible = false;
            setTimeout(() => {
              this.loading = false;
              this.getListData();
            }, 300);
          } else {
            this.loading = false;
            this.$message({
              type: "error",
              message: res.data,
            });
          }
        });
      }
    },

    /* 删除 */
    handleDelete(row) {
   
      this.$confirm("此操作将永久删除该会员卡, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
       
          deleteVipCard({ id: row.id }).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}

/* 筛选区：白色圆角卡片上半部，与表格拼接成一整块白卡 */
.filter-bar {
  background: #fff;
  border-radius: 8px 8px 0 0;
  padding: 16px 16px 12px;
  margin: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  /* 筛选项占满左侧，换行时整体仍对齐 */
  .filter-form {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
  }
  /deep/ .el-form-item {
    margin-right: 16px;
    margin-bottom: 8px;

    .el-input__inner {
      width: 200px;
    }
  }
  /* 新增/搜索按钮无 label，单独上移一点与输入框视觉对齐 */
  .item-add,
  .item-search {
    margin-top: -6px;
  }

  /* 右侧统计，填补右端空白、平衡一行视觉重心 */
  .filter-meta {
    flex-shrink: 0;
    padding-top: 6px;
    font-size: 13px;
    color: #8a94a6;

    .meta-num {
      color: #3d8dfc;
      font-weight: 600;
    }
  }
}
.tableList {
  border-radius: 0 0 8px 8px;
  background: #fff;
  margin: 0;
  padding: 0 16px 40px;
}

.operation {
  a {
    margin-right: 10px;
  }
}
</style>

<!-- 弹窗挂到 body，需用非 scoped 样式才能作用 -->
<style lang="less">
.vip-dialog {
  border-radius: 10px;
  overflow: hidden;

  .el-dialog__header {
    padding: 20px 24px 10px;
    border-bottom: 1px solid #f0f0f0;

    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }
  }
  .el-dialog__body {
    padding: 16px 24px 4px;

    .dialog-tip {
      font-size: 13px;
      color: #8a94a6;
      line-height: 1.6;
      margin-bottom: 16px;
    }

    .vip-form {
      .el-form-item {
        margin-bottom: 16px;
        background: #f7f9fc;
        border: 1px solid #eef1f6;
        border-radius: 10px;
        padding: 14px 14px 16px;
        transition: border-color 0.2s, box-shadow 0.2s;

        .el-form-item__label {
          line-height: 1.4;
          padding-bottom: 6px;
          font-size: 13px;
          font-weight: 500;
          color: #5a6478;
        }
        .el-input__inner {
          width: 100%;
          border-radius: 8px;
          background: #fff;
          border-color: #dfe4ec;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .el-input__inner:focus {
          border-color: #3d8dfc;
          box-shadow: 0 0 0 3px rgba(61, 141, 252, 0.12);
        }
      }
      .el-form-item.is-focus,
      .el-form-item:focus-within {
        border-color: #3d8dfc;
        box-shadow: 0 0 0 3px rgba(61, 141, 252, 0.08);
      }
    }
  }
  .el-dialog__footer {
    padding: 12px 24px 22px;

    .dialog-footer .el-button {
      padding: 9px 22px;
    }
    .el-button--primary {
      background: #3d8dfc;
      border-color: #3d8dfc;

      &:hover {
        background: #2f7be0;
        border-color: #2f7be0;
      }
    }
  }
}
</style>
